import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import { CircularProgress } from "@mui/material";
import AppContext from "../../container/context";

export default function EventosPedido(props) {
  const history = props.history;
  const [eventoPedidoId] = useState(Number(props.match.params.id));
  const [carregando, setCarregando] = useState(false);
  const [dados, setDados] = useState({});
  const { notification } = useContext(AppContext);

  useEffect(() => {
    if (eventoPedidoId > 0) {
      carregar();
    }
  }, []);

  const carregar = () => {
    setCarregando(true);

    api
      .get("eventosPedido/carregar", { id: eventoPedidoId })
      .then((res) => {
        setDados(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar eventos de pedido");
        setCarregando(false);
      });
  };

  const salvar = (form) => {
    if (eventoPedidoId > 0) form.id = eventoPedidoId;

    setDados(form);

    if (eventoPedidoId === 0) {
      api
        .post("eventosPedido/inserir", form)
        .then((res) => {
          notification("success", "Evento de pedido inserido");
          setDados({});
          history.push(`/app/eventos-pedido`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .post("eventosPedido/editar", form)
        .then((res) => {
          notification("success", "Evento de pedido editado!");
          setDados({});
          history.push(`/app/eventos-pedido`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fDados = {
    title: "Evento de pedido",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: dados.nome,
      },
      ordem: {
        label: "Ordem",
        type: "number",
        space: 3,
        value: dados.ordem,
      },
      cor: {
        label: "Cor",
        type: "color",
        space: 3,
        value: dados.cor,
      },
      descricao: {
        label: "Descrição",
        type: "textarea",
        space: 12,
        value: dados.descricao,
      },
      inativacao: {
        label: "Data inativação",
        type: "date",
        space: 12,
        value: dados.inativacao,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  return (
    <div> {carregando ? <CircularProgress /> : <Form formData={fDados} />}</div>
  );
}
